import { map, each } from 'lodash';
/**
 * 页面级子菜单权限设置
 * 1.判断路由名称是否属于当前路由列表,如果不属于，直接返回，不影响其他路由。
 * 2.如果属于，判断跳转的是否有权限，如果有直接跳转。
 * 3.如果没有权限的话，查找路由列表，直到找到具备权限的路由名称，则跳转到该路由。
 */
export async function faceMenuRouteHook(params, routePermissionTable) {
    const { $P, to, next, } = params;
    const routeNames = new Set(map(routePermissionTable, t => t.name));
    const routePermissionMap = {};
    each(routePermissionTable, item => {
        const { name, permission, } = item;
        routePermissionMap[name] = permission;
    });
    /* 如果对应模块下的路由，直接返回 */
    if (!routeNames.has(to.name)) {
        return false;
    }
    /* 如果对应模块下的路由且具备权限，则直接跳转 */
    if ($P(routePermissionMap[to.name])) {
        await next();
        return true;
    }
    /* 如果是对应模块下的路由且不具备权限，则向下判断找有权限的路由跳转 */
    for (let i = 0; i < routePermissionTable.length; i++) {
        const { name, permission, } = routePermissionTable[i];
        if ($P(permission)) {
            await next({ name });
            return true;
        }
    }
    return false;
}
export var E_ROUTE_ACCOUNT;
(function (E_ROUTE_ACCOUNT) {
    E_ROUTE_ACCOUNT["ACCOUNTS"] = "accounts";
    E_ROUTE_ACCOUNT["ACCOUNT_NEXT"] = "account-next";
    E_ROUTE_ACCOUNT["ACCOUNT_DEFAULT"] = "account-default";
    E_ROUTE_ACCOUNT["ACCOUNT_HISTORY"] = "account-history";
    E_ROUTE_ACCOUNT["ACCOUNT_CAPACITY"] = "account-capacity";
    E_ROUTE_ACCOUNT["ACCOUNT_LOGIN_HISTORY"] = "account-login-history";
    E_ROUTE_ACCOUNT["ACCOUNT_COMPANY_REPORT"] = "account-company-report";
    E_ROUTE_ACCOUNT["ACCOUNT_SETTING"] = "account-setting";
    E_ROUTE_ACCOUNT["ACCOUNT_DEFAULT_SETTING"] = "account-default-setting";
    E_ROUTE_ACCOUNT["ACCOUNT_SYSTEM_LIMIT"] = "account-system-limit";
    E_ROUTE_ACCOUNT["ACCOUNT_SUBSCRIPTIONS"] = "account-subscriptions";
    E_ROUTE_ACCOUNT["ACCOUNT_PRODUCT"] = "account-product";
    E_ROUTE_ACCOUNT["ACCOUNT_TENANT"] = "account_tenant";
    /**
     * 数据分析
     */
    E_ROUTE_ACCOUNT["ACCOUNT_DATA_ANALYSIS"] = "account-data-analysis";
})(E_ROUTE_ACCOUNT || (E_ROUTE_ACCOUNT = {}));
export var E_ROUTE_COMPANY_ORGANIZATION;
(function (E_ROUTE_COMPANY_ORGANIZATION) {
    E_ROUTE_COMPANY_ORGANIZATION["COMPANIES"] = "companies";
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_NEXT"] = "company-next";
    /** 产品 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_PRODUCTS"] = "company-products";
    /** 权限 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_PRIVILEGE"] = "company-privilege";
    /** 常规设置 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_PROFILE"] = "company-profile";
    /** 设置 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_ENTERPRISE"] = "company-enterprise";
    /** 臭氧设置 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_SUBSCRIPTIONS"] = "company-subscriptions";
    /**
     * 自注册及权限分配
     */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_SELF_REGISTER_AND_PRIVILEGE_SETTING"] = "company-self-register-and-privilege-setting";
    /** 安全设置 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_SAFESETTING"] = "company-safeSetting";
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_DEFAULT_SETTING"] = "company-default-setting";
    /** grant 设置 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_GRANT"] = "company-grant";
    /** SSO 设置 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_SSO"] = "company-sso";
    /** 系统限制 */
    E_ROUTE_COMPANY_ORGANIZATION["SYSTEM_LIMIT"] = "company-system-limit";
    /** 用户 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_ACCOUNTS"] = "company-accounts";
    /** 报告 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_REPORT"] = "company-report";
    /** 公司历史 */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_HISTORY"] = "company-history";
    /**
     * 公司容量
     */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_CAPACITY"] = "company-capacity";
    /**
     * 公司订单列表
     */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_ORDER_LIST"] = "company-orderList";
    /**
     * 客户360
     */
    E_ROUTE_COMPANY_ORGANIZATION["CUSTOMER_360"] = "customer360";
    /**
     * 数据分析
     */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_DATA_ANALYSIS"] = "company-data-analysis";
    /**
     * 客户洞察
     */
    E_ROUTE_COMPANY_ORGANIZATION["COMPANY_INSIGHTS"] = "company-insights";
})(E_ROUTE_COMPANY_ORGANIZATION || (E_ROUTE_COMPANY_ORGANIZATION = {}));
/**
 * 运营工具-推荐管理
 */
export var E_ROUTR_RECOMMENDATION_MANAGEMENT;
(function (E_ROUTR_RECOMMENDATION_MANAGEMENT) {
    E_ROUTR_RECOMMENDATION_MANAGEMENT["HOME_PAGE_CONFIGURATION"] = "home-page-configuration";
    E_ROUTR_RECOMMENDATION_MANAGEMENT["HOME_PAGE_CONFIGURATION_PRODUCTS"] = "home-page-configuration-products";
    E_ROUTR_RECOMMENDATION_MANAGEMENT["HOME_PAGE_CONFIGURATION_ADVERT"] = "home-page-configuration-advert";
    E_ROUTR_RECOMMENDATION_MANAGEMENT["DASHBOARD_EDITORSPICK_MANAGEMENT"] = "dashboard-editorsPick-management";
})(E_ROUTR_RECOMMENDATION_MANAGEMENT || (E_ROUTR_RECOMMENDATION_MANAGEMENT = {}));
/**
 * 运营工具-patsnapLab
 */
export var E_ROUTE_PATSNAPLAB;
(function (E_ROUTE_PATSNAPLAB) {
    E_ROUTE_PATSNAPLAB["PATSNAP_LAB"] = "patsnap-lab";
    E_ROUTE_PATSNAPLAB["PATSNAP_LAB_ANALYSIS"] = "patsnap-lab-analysis";
    E_ROUTE_PATSNAPLAB["PATSNAP_LAB_FEEDBACK"] = "patsnap-lab-feedback";
})(E_ROUTE_PATSNAPLAB || (E_ROUTE_PATSNAPLAB = {}));
export var E_ROUTE_DEVELOPER_TOOL_COREUTILITY;
(function (E_ROUTE_DEVELOPER_TOOL_COREUTILITY) {
    /** 账号信息查询 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["ACCOUNT_INFORMATION_QUERY"] = "account-Information-query";
    /** 账号信息查询-用户 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["ACCOUNT_INFORMATION_QUERY_USER"] = "account-Information-query-user";
    /** 账号信息查询-公司 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["ACCOUNT_INFORMATION_QUERY_COMPANY"] = "account-Information-query-company";
    /** 缓冲管理 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["CACHE_MANAGEMENT"] = "cache-management";
    /** 缓冲管理-默认搜索 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["CACHE_MANAGEMENT_DEFAULT_SEARCH"] = "cache-management-default-search";
    /** 缓冲管理-条件搜索 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["CACHE_MANAGEMENT_CUSTOM_SEARCH"] = "cache-management-custom-search";
    /** 缓存管理-管理 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["CACHE_MANAGEMENT_MANAGE_SEARCH"] = "cache-management-manage-search";
    /** 缓存管理-redis */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["CACHE_MANAGEMENT_REDIS_SEARCH"] = "cache-management-redis-search";
    /** 邮件Alert测试 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["EMAIL_ALERT_TEST"] = "email-alert-test";
    /** 邮件Alert调试 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["EMAIL_ALERT_DEBUGGER"] = "email-alert-debugger";
    /** 网关权限 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["GATEWAY_PERMISSIONS"] = "gateway-permissions";
    /** 日志 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["COREUTILITY_LIMITATION"] = "coreUtility-limitation";
    /** Core工具-接口调试 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["POSTMAN"] = "postman";
    /** TFFI 缓存管理 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["CacheManagementTFFI"] = "cache-management-TFFI";
    /** 配置列表 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["CONFIG_LIST"] = "config-list";
    /** 并发信息邮件测试 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["EMAIL_CONCURRENCY_TEST"] = "email-concurrency-test";
    /** 运营数据更新 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["OPERATION_ADD_TRIAL"] = "operation-add-trial";
    /** 更新用户job title & manual company */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["OPERATION_ADD"] = "operation-add";
    /** 给用户增加试用权限 */
    E_ROUTE_DEVELOPER_TOOL_COREUTILITY["OPERATION_TRIAL"] = "operation-trial";
})(E_ROUTE_DEVELOPER_TOOL_COREUTILITY || (E_ROUTE_DEVELOPER_TOOL_COREUTILITY = {}));
/**
 * 系统
 */
export var E_ROUTE_SYSTEM;
(function (E_ROUTE_SYSTEM) {
    E_ROUTE_SYSTEM["SEARCH_ENGINE_MANAGEMENT"] = "search-engine-management";
    E_ROUTE_SYSTEM["SYSTEM_CACHE_MANAGEMENT"] = "system-cache-management";
    E_ROUTE_SYSTEM["SYSTEM_MAIL_UNREACHABLE"] = "system-mail-unreachable";
    E_ROUTE_SYSTEM["SYSTEM_SAML"] = "system-saml";
    E_ROUTE_SYSTEM["SYNCHRONIZATION_REDIS"] = "synchronization-redis";
    E_ROUTE_SYSTEM["SYSTEM_SQL"] = "system-sql";
})(E_ROUTE_SYSTEM || (E_ROUTE_SYSTEM = {}));
/**
 * 搜索管理引擎
 */
export var E_ROUTE_SEARCHENGINE_MANAGEMENT;
(function (E_ROUTE_SEARCHENGINE_MANAGEMENT) {
    /** 搜索引擎管理-历史 */
    E_ROUTE_SEARCHENGINE_MANAGEMENT["HISTORY"] = "search-engine-management-history";
    /** 搜索引擎管理-用户 */
    E_ROUTE_SEARCHENGINE_MANAGEMENT["ACCOUNT"] = "search-engine-management-account";
    /** 搜索引擎管理-公司 */
    E_ROUTE_SEARCHENGINE_MANAGEMENT["COMPANY"] = "search-engine-management-company";
    // Package
    E_ROUTE_SEARCHENGINE_MANAGEMENT["PACKAGE"] = "search-engine-management-package";
    // Group
    E_ROUTE_SEARCHENGINE_MANAGEMENT["GROUP"] = "search-engine-management-group";
    // Group Member
    E_ROUTE_SEARCHENGINE_MANAGEMENT["GROUP_MEMBER"] = "search-engine-management-group-member";
})(E_ROUTE_SEARCHENGINE_MANAGEMENT || (E_ROUTE_SEARCHENGINE_MANAGEMENT = {}));
/**
 * 故障排除
 * 会话踢出信息
 * 不可达邮件
 */
export var E_ROUTE_TROUBLESHOOTING;
(function (E_ROUTE_TROUBLESHOOTING) {
    /**
     * 会话踢出信息
     */
    E_ROUTE_TROUBLESHOOTING["TROUBLESHOOTING_KICKOUT"] = "troubleshooting-kickout";
    E_ROUTE_TROUBLESHOOTING["TROUBLESHOOTING_MAIL"] = "troubleshooting-mail";
    E_ROUTE_TROUBLESHOOTING["TROUBLESHOOTING_MESSAGESEND"] = "troubleshooting-message-send";
    /** 会话管理 */
    E_ROUTE_TROUBLESHOOTING["SESSSION_MANAGER"] = "session-manager";
    /** 会话管理-用户 */
    E_ROUTE_TROUBLESHOOTING["SESSSION_MANAGER_USER"] = "session-manager-user";
    /** 会话管理-公司 */
    E_ROUTE_TROUBLESHOOTING["SESSSION_MANAGER_COMPANY"] = "session-manager-company";
    /**
     * 通知中心
     */
    E_ROUTE_TROUBLESHOOTING["MESSAGE_MANAGER"] = "notice-center";
})(E_ROUTE_TROUBLESHOOTING || (E_ROUTE_TROUBLESHOOTING = {}));
export var E_ROUTE_NOTICE_CENTER;
(function (E_ROUTE_NOTICE_CENTER) {
    // 通知明细
    E_ROUTE_NOTICE_CENTER["NOTICE_DETAIL"] = "notice-center-notification-detail";
    // 配置管理
    E_ROUTE_NOTICE_CENTER["NOTICE_CONFIGURATION"] = "notice-center-configuration";
    // 数据分析
    E_ROUTE_NOTICE_CENTER["NOTICE_DATA_ANALYSIS"] = "notice-center-data-analysis";
})(E_ROUTE_NOTICE_CENTER || (E_ROUTE_NOTICE_CENTER = {}));
export var E_ROUTE_MAILMANAGEMENT;
(function (E_ROUTE_MAILMANAGEMENT) {
    E_ROUTE_MAILMANAGEMENT["SETTING"] = "troubleshooting-mail-setting";
    E_ROUTE_MAILMANAGEMENT["SEND"] = "troubleshooting-mail-send";
    E_ROUTE_MAILMANAGEMENT["RECEIPT"] = "troubleshooting-mail-receipt";
    E_ROUTE_MAILMANAGEMENT["UNREACHABLE"] = "troubleshooting-mail-unreachable";
    E_ROUTE_MAILMANAGEMENT["ANALYSIS"] = "troubleshooting-mail-analysis";
})(E_ROUTE_MAILMANAGEMENT || (E_ROUTE_MAILMANAGEMENT = {}));
// #region Open API Analysis
export var E_ROUTE_OPEN_API_ANALYSIS;
(function (E_ROUTE_OPEN_API_ANALYSIS) {
    E_ROUTE_OPEN_API_ANALYSIS["OPENAPIANALYSIS"] = "openApiAnalysis";
    E_ROUTE_OPEN_API_ANALYSIS["OPENAPIMONTHLYBILL"] = "openApiMonthlyBill";
    E_ROUTE_OPEN_API_ANALYSIS["OPENAPIPACKAGEUSAGE"] = "openApiPackageUsage";
    E_ROUTE_OPEN_API_ANALYSIS["OPENAPICUSTOMERUSAGERANKING"] = "openApiCustomerUsageRanking";
    E_ROUTE_OPEN_API_ANALYSIS["OPENAPIPACKAGEUSAGERANKING"] = "openApiPackageUsageRanking";
    E_ROUTE_OPEN_API_ANALYSIS["OPENAPIAPIUSAGERANKING"] = "openApiApiUsageRanking";
})(E_ROUTE_OPEN_API_ANALYSIS || (E_ROUTE_OPEN_API_ANALYSIS = {}));
// #endregion
// #region Open API Content Configurable
export var E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE;
(function (E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE) {
    E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE["OPENAPI_CONTENT_CONFIGURABLE"] = "open-api-content-configurable";
    E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE["OPENAPI_CONTENT_CONFIGURABLE_INDEX"] = "open-api-content-configurable-home";
    E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE["OPENAPI_CONTENT_CONFIGURABLE_SOLUTION_GROUP"] = "open-api-content-configurable-solution-group";
    E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE["OPENAPI_CONTENT_CONFIGURABLE_SOLUTION"] = "open-api-content-configurable-solution";
    E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE["OPENAPI_CONTENT_CONFIGURABLE_DATA_PACKAGE"] = "open-api-content-configurable-data-package";
})(E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE || (E_ROUTE_OPEN_API_CONTENT_CONFIGURABLE = {}));
// #endregion
// #region Open API Inno API
export var E_ROUTE_OPEN_API_INNO_API;
(function (E_ROUTE_OPEN_API_INNO_API) {
    E_ROUTE_OPEN_API_INNO_API["OPENAPI_INNO_API"] = "open-api-inno-api";
    E_ROUTE_OPEN_API_INNO_API["OPENAPI_INNO_API_MANAGEMENT"] = "/open-api/key-management";
    E_ROUTE_OPEN_API_INNO_API["OPENAPI_INNO_API_RECHARGE"] = "open-api/key-recharge-record";
})(E_ROUTE_OPEN_API_INNO_API || (E_ROUTE_OPEN_API_INNO_API = {}));
// #endregion
export var E_ROUTE_COMMON;
(function (E_ROUTE_COMMON) {
    E_ROUTE_COMMON["LOGIN"] = "login";
    E_ROUTE_COMMON["ERROR_404"] = "error-404";
    E_ROUTE_COMMON["ERROR_403"] = "error-403";
})(E_ROUTE_COMMON || (E_ROUTE_COMMON = {}));
// #region Data Analysis
export var E_ROUTE_DATA_ANALYSIS;
(function (E_ROUTE_DATA_ANALYSIS) {
    E_ROUTE_DATA_ANALYSIS["USER_ANALYSIS"] = "UserAnalysis";
})(E_ROUTE_DATA_ANALYSIS || (E_ROUTE_DATA_ANALYSIS = {}));
// #endregion
export var E_ROUTE_ADMIN;
(function (E_ROUTE_ADMIN) {
    E_ROUTE_ADMIN["ADMIN"] = "admin";
    E_ROUTE_ADMIN["ACCOUNTS"] = "admin-accounts";
    E_ROUTE_ADMIN["ROLES"] = "admin-roles";
    E_ROUTE_ADMIN["HISTORY"] = "admin-history";
    E_ROUTE_ADMIN["AUDIT"] = "admin-audit";
    E_ROUTE_ADMIN["ORGANIZATION"] = "admin-organization";
    E_ROUTE_ADMIN["CORS_WHITELIST"] = "admin-cors-whitelist";
})(E_ROUTE_ADMIN || (E_ROUTE_ADMIN = {}));
export var E_BEHAVIOR;
(function (E_BEHAVIOR) {
    E_BEHAVIOR["DashBoard"] = "DashBoard";
    E_BEHAVIOR["ActiveBoard"] = "ActiveBoard";
    E_BEHAVIOR["GlobalViewBoard"] = "GlobalViewBoard";
})(E_BEHAVIOR || (E_BEHAVIOR = {}));
// #endregion
export var PRODUCT_DATA_STATISTICS;
(function (PRODUCT_DATA_STATISTICS) {
    PRODUCT_DATA_STATISTICS["PRODUCT_OVERVIEW"] = "ProductOverview";
    PRODUCT_DATA_STATISTICS["PRODUCT_DATA_STATISTICS"] = "ProductDataStatistics";
    PRODUCT_DATA_STATISTICS["ANALYTICS"] = "AnalyticsDataStatistics";
    PRODUCT_DATA_STATISTICS["WORKSPACE"] = "WorkspaceDataStatistics";
    PRODUCT_DATA_STATISTICS["BACKOFFICE"] = "BackofficeDataStatistics";
    PRODUCT_DATA_STATISTICS["ADMIN"] = "AdminDataStatistics";
    PRODUCT_DATA_STATISTICS["EUREKA"] = "EurekaDataStatistics";
    PRODUCT_DATA_STATISTICS["INSIGHTS"] = "InsightsDataStatistics";
    PRODUCT_DATA_STATISTICS["BI"] = "BIDataStatistics";
    PRODUCT_DATA_STATISTICS["FEATURE"] = "FeatureDataStatistics";
})(PRODUCT_DATA_STATISTICS || (PRODUCT_DATA_STATISTICS = {}));
export var E_DATA_PROTECTION;
(function (E_DATA_PROTECTION) {
    E_DATA_PROTECTION["DATA_PROTECTION"] = "dataProtection";
    E_DATA_PROTECTION["RULE_MANAGEMENT"] = "ruleManagement";
    E_DATA_PROTECTION["COMPANY_TREE"] = "CompanyTree";
    E_DATA_PROTECTION["EXPORT_MANAGEMENT"] = "exportManagement";
    E_DATA_PROTECTION["RESTRICTION_LIST"] = "restrictionList";
    E_DATA_PROTECTION["WHITELIST_MANAGEMEN"] = "whitelistManagement";
    E_DATA_PROTECTION["USER_RESTRICTED_QUERY"] = "userRestrictedQuery";
    E_DATA_PROTECTION["ILLEGAL_MANAGEMENT"] = "illegalManagement";
    E_DATA_PROTECTION["ILLEGAL_IP_MANAGEMENT"] = "illegalIpManagement";
    E_DATA_PROTECTION["ILLEGAL_COMPANY_MANAGEMENT"] = "illegalCompanyManagement";
    E_DATA_PROTECTION["ILLEGAL_ACCOUNT_MANAGEMENT"] = "illegalAccountManagement";
})(E_DATA_PROTECTION || (E_DATA_PROTECTION = {}));
export var E_PAGESSECTION;
(function (E_PAGESSECTION) {
    E_PAGESSECTION["INTERPRETATION"] = "Interpretation";
    E_PAGESSECTION["SELECTION"] = "selection";
})(E_PAGESSECTION || (E_PAGESSECTION = {}));
export var E_ROUTE_PROMPT_MANAGEMENT;
(function (E_ROUTE_PROMPT_MANAGEMENT) {
    E_ROUTE_PROMPT_MANAGEMENT["HOME"] = "PromptManagementHome";
})(E_ROUTE_PROMPT_MANAGEMENT || (E_ROUTE_PROMPT_MANAGEMENT = {}));
export var E_ROUTE_EMAIL_TEMPLATE_MANAGEMENT;
(function (E_ROUTE_EMAIL_TEMPLATE_MANAGEMENT) {
    E_ROUTE_EMAIL_TEMPLATE_MANAGEMENT["HOME"] = "EmailTemplateManagementHome";
})(E_ROUTE_EMAIL_TEMPLATE_MANAGEMENT || (E_ROUTE_EMAIL_TEMPLATE_MANAGEMENT = {}));
export var E_ROUTE_ORGANIZATION_MANAGEMENT;
(function (E_ROUTE_ORGANIZATION_MANAGEMENT) {
    E_ROUTE_ORGANIZATION_MANAGEMENT["HOME"] = "OrganizationManagementHome";
})(E_ROUTE_ORGANIZATION_MANAGEMENT || (E_ROUTE_ORGANIZATION_MANAGEMENT = {}));
/**
 * 运营工具
 */
export var E_ROUTE_OPERATION_TOOLS;
(function (E_ROUTE_OPERATION_TOOLS) {
    /**
     * 产品资源位管理
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT"] = "productResourceSpaceManagement";
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_NAV"] = "productResourceSpaceManagementNav";
    /**
     * 产品资源位管理-内容
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT"] = "productResourceSpaceManagementContent";
    /**
     * 产品资源位管理-内容-详情
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL"] = "productResourceSpaceManagementContentDetail";
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL_VIEW"] = "productResourceSpaceManagementContentDetailView";
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL_RULE"] = "productResourceSpaceManagementContentDetailRule";
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_DETAIL_RECORD"] = "productResourceSpaceManagementContentDetailRecord";
    /**
     * 产品资源位管理-内容-编辑
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_EDIT"] = "productResourceSpaceManagementContentEdit";
    /**
     * 产品资源位管理-内容-新增
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_CONTENT_ADD"] = "productResourceSpaceManagementContentAdd";
    /**
     * 产品资源位管理-资源位
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_RESOURCE_SPACE"] = "productResourceSpaceManagementResourceSpace";
    /**
     * 产品资源位管理-资源位-编辑
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_RESOURCE_SPACE_EDIT"] = "productResourceSpaceManagementResourceSpaceEdit";
    /**
     * 产品资源位管理-资源位-新增
     */
    E_ROUTE_OPERATION_TOOLS["PRODUCT_RESOURCE_SPACE_MANAGEMENT_RESOURCE_SPACE_ADD"] = "productResourceSpaceManagementResourceSpaceAdd";
    /**
     * 运营推广链接
     */
    E_ROUTE_OPERATION_TOOLS["OPERATION_PROMOTION_LINL"] = "operationPromotionPink";
    /**
     * 运营管理-PQL规则管理
     */
    E_ROUTE_OPERATION_TOOLS["OPERATION_PQL_RULE_MANAGEMENT"] = "operationPqlRuleManagement";
    E_ROUTE_OPERATION_TOOLS["OPERATION_PQL_RULE_MANAGEMENT_NAV"] = "operationPqlRuleManagementNav";
    E_ROUTE_OPERATION_TOOLS["OPERATION_PQL_RULE_MANAGEMENT_ANALYSIS"] = "operationPqlRuleManagementAnalysis";
})(E_ROUTE_OPERATION_TOOLS || (E_ROUTE_OPERATION_TOOLS = {}));
